import "../base.js";
import "../../../../utilities/appointment_date.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotSuggester ??= {};
window.AppointmentBooking.SlotSuggester.Views ??= {};
window.AppointmentBooking.SlotSuggester.Views.Reselector ??= {};

AppointmentBooking.SlotSuggester.Views.Reselector.ProviderSelector = class ProviderSelector extends (
  AppointmentBooking.SlotSuggester.Views.Base
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.contextForRender = this.contextForRender.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    // BEHAVIOUR

    return this.listenTo(this.model, "reset change:selectedProviderOption", this.render);
  }

  // EVENT HANDLERS

  handleProviderOptionClick(event) {
    let selectedDate;
    const providerOption = jQuery(event.currentTarget).data("provider-option");
    if (providerOption === "desired") {
      selectedDate = __guard__(this.desiredProviderSlots.first(), (x) => x.get("startTime")) || moment();
    } else {
      selectedDate = __guard__(this.poolSlots.first(), (x1) => x1.get("startTime")) || moment();
    }

    return this.model.set({ selectedProviderOption: providerOption, selectedDate });
  }

  // RENDERING

  contextForRender() {
    let metadata;
    const context = super.contextForRender(...arguments);
    context.metadata = metadata = {};
    context.desiredProvider = null; // We need the template to know about this local variable

    if (this.desiredProvider) {
      context.desiredProvider = this.desiredProvider.toJSON();
    }

    if (this.desiredStartTime) {
      metadata.sameTimeAvailable = __guard__(
        this.poolSlots.find((slot) => slot.startMoment.isSame(this.desiredStartTime)),
        (x) => x.get("startTime"),
      );
      metadata.earlierTimeAvailable = __guard__(
        this.poolSlots.find(
          (slot) =>
            slot.startMoment.isSame(this.desiredStartTime, "day") && slot.startMoment.isBefore(this.desiredStartTime),
        ),
        (x1) => x1.get("startTime"),
      );
      metadata.earliestTimeAvailable = __guard__(this.poolSlots.first(), (x2) => x2.get("startTime")); // We rely on the suggested slots being sorted by start time
    }

    return context;
  }
};

AppointmentBooking.SlotSuggester.Views.Reselector.ProviderSelector.prototype.tagName = "div";
AppointmentBooking.SlotSuggester.Views.Reselector.ProviderSelector.prototype.template = "reselector/provider_selector";
AppointmentBooking.SlotSuggester.Views.Reselector.ProviderSelector.prototype.className =
  "appointment-booking-slot-reselector__provider-selector";
AppointmentBooking.SlotSuggester.Views.Reselector.ProviderSelector.prototype.events = {
  "click [data-provider-option]": "handleProviderOptionClick",
};

AppointmentBooking.SlotSuggester.Views.Reselector.ProviderSelector.get("desiredProvider", function () {
  return this.model.get("desiredProvider");
});

AppointmentBooking.SlotSuggester.Views.Reselector.ProviderSelector.get("availableProviders", function () {
  return this.model.get("availableProviders");
});

AppointmentBooking.SlotSuggester.Views.Reselector.ProviderSelector.get("desiredProviderSlots", function () {
  return this.model.get("desiredProviderSlots");
});

AppointmentBooking.SlotSuggester.Views.Reselector.ProviderSelector.get("poolSlots", function () {
  return this.model.get("poolSlots");
});

AppointmentBooking.SlotSuggester.Views.Reselector.ProviderSelector.get("desiredStartTime", function () {
  return this.model.get("desiredStartTime");
});

AppointmentBooking.SlotSuggester.Views.Reselector.ProviderSelector.get("selectedDate", function () {
  return this.model.get("selectedDate");
});

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}
